import * as React from "react";
import Box from "@mui/material/Box";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import TextField from "@mui/material/TextField";
import {useEffect, useState, useRef} from "react";
import {connect} from "react-redux";
import scan_img from '../scan.png'
import audio_err from '../warn.mp3'
import audio_finish from '../finish.mp3'
import {editSaveDocument, getAlLThis, getDocument, messageReset} from "../store/documents";
import axios from 'axios';
import {getAllVerifyResponse} from "../store/logIn";
import Dialog from '@mui/material/Dialog';
import {Slide, toast} from "react-toastify";

function EditDocument(props) {
    let audio = new Audio(audio_err)
    let finish = new Audio(audio_finish)
    const navigate = useNavigate()
    const params = useParams()
    const [searchParams] = useSearchParams()
    const [code, setCode] = useState('')
    const [thisOpen, setThisOpen] = useState(false)
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    // Get track type from URL or openItem
    const trackType = React.useMemo(() => {
        // First try to get from URL params
        let type = searchParams.get('type')
        if (!type) {
            if (searchParams.has('avia')) {
                type = 'avia'
            } else if (searchParams.has('fura')) {
                type = 'fura'
            }
        }
        // Fallback to openItem type
        return type || props.openItem?.type
    }, [searchParams, props.openItem])

    // Helper function to get the correct location field based on track type
    const getLocationField = (item) => {
        if (trackType === 'avia') {
            return item.place; // For avia, use 'place'
        } else if (trackType === 'fura') {
            return item.location || item.place; // For fura, use 'location', fallback to 'place'
        }
        return item.place; // Default fallback
    };

    // Helper function to check if item is in China
    const isInChina = (item) => {
        const location = getLocationField(item);
        return location === 'china';
    };

    // Helper function to check if item is in Uzbekistan
    const isInUzbekistan = (item) => {
        const location = getLocationField(item);
        return location === 'uz' || location === 'uzb';
    };

    // Add ref for the TextField
    const textFieldRef = useRef(null);

    // Enhanced refs for better completion tracking
    const shouldCheckCompletion = useRef(false);
    const lastDocumentCount = useRef(0);
    const completionCheckTimeout = useRef(null);
    const isScanning = useRef(false);
    const initialDocumentCount = useRef(0);
    const scanCount = useRef(0); // Track number of successful scans
    const initialChinaDocs = useRef([]); // Store initial china documents

    const handleClose = () => {
        setOpen(false);
        props.setOpen(false)
        props.setOpenItem(false)
        // Reset all completion check flags when closing
        shouldCheckCompletion.current = false;
        isScanning.current = false;
        scanCount.current = 0;
        setThisOpen(false);
        initialChinaDocs.current = [];

        // Clear any pending completion checks
        if (completionCheckTimeout.current) {
            clearTimeout(completionCheckTimeout.current);
            completionCheckTimeout.current = null;
        }
    };

    useEffect(() => {
        if (props.open) {
            setOpen(props.open)
            // Initialize the document count when modal opens - using the helper function
            const chinaDocs = props.documents.filter(item => isInChina(item));
            lastDocumentCount.current = chinaDocs.length;
            initialDocumentCount.current = chinaDocs.length;
            initialChinaDocs.current = [...chinaDocs]; // Store initial china docs


            // Reset completion check flags when opening
            shouldCheckCompletion.current = false;
            isScanning.current = false;
            scanCount.current = 0;

            // Focus the input when modal opens
            setTimeout(() => {
                if (textFieldRef.current) {
                    textFieldRef.current.focus();
                }
            }, 50);
        }
    }, [props.open, trackType])

    // Improved completion check with better logic
    const checkForCompletion = () => {

        // Clear any existing timeout
        if (completionCheckTimeout.current) {
            clearTimeout(completionCheckTimeout.current);
        }

        // Always refresh data for both types after scanning
        const data = {
            "part": params['part'],
            "code": params['code'],
            "type": trackType
        }
        props.getAlLThis(data);

        // Set a timeout to check completion after data refresh
        completionCheckTimeout.current = setTimeout(() => {
            const currentChinaDocs = props.documents.filter(item => isInChina(item));
            const currentDestDocs = props.documents.filter(item => isInUzbekistan(item));

            // Only proceed if we should check and we're not currently scanning
            if (shouldCheckCompletion.current && !isScanning.current && scanCount.current > 0) {
                // Check if all china documents have been moved to destination
                const allCompleted = (
                    currentChinaDocs.length === 0
                );

                if (allCompleted) {
                    finish.play();
                    toast.success("Barchasi muvaffaqiyatli saqlandi!", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        progress: undefined,
                        theme: "colored",
                        transition: Slide,
                    })
                    props.messageReset()

                    // Reset flags to prevent repeated completion
                    shouldCheckCompletion.current = false;

                    // Close the modal after showing the success message
                    setTimeout(() => {
                        handleClose();
                    }, 300);
                }
            }
        }, 1000); // Increased delay to ensure data is properly updated for fura
    };

    useEffect(() => {
        const delayDebounceFn = setTimeout(async () => {
            if (code && props.openItem && !loading){
                setLoading(true);

                try {
                    const trackType = props.openItem['type'];

                    const scanData = {
                        serial_number: props.openItem['part'],
                        code: props.openItem['code'],
                        track_code: code,
                        type: trackType
                    };

                    const response = await axios.patch(`https://fx.softmakon.uz/api/combined-tracking/scan/`, scanData);

                    if (response.status === 200) {
                        // Check if this was already scanned
                        if (response.data.already_scanned) {
                            // Item was already scanned - do nothing silently
                            setCode('');
                            // Don't play sound, don't show toast, don't close modal
                            // Just clear the input and continue
                        } else {
                            // Item was newly scanned - show success feedback
                            toast.success("Muvaffaqiyatli saqlandi!", {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false,
                                progress: undefined,
                                theme: "colored",
                                transition: Slide,
                            });

                            setThisOpen(true);
                            setCode('');
                            scanCount.current += 1; // Increment scan count


                            // Wait before enabling completion check
                            setTimeout(() => {
                                isScanning.current = false; // Clear scanning flag
                                // Only enable completion check after successful scan
                                shouldCheckCompletion.current = true;
                                checkForCompletion();

                                // REFOCUS THE INPUT AFTER SCAN COMPLETES
                                if (textFieldRef.current) {
                                    textFieldRef.current.focus();
                                }
                            }, 600); // Increased delay to allow state updates
                        }
                    }
                } catch (error) {
                    console.error('Error scanning document:', error);
                    audio.play();

                    let errorMessage = "Xatolik! Trek kod to'g'ri kelmadi!";
                    if (error.response?.data?.error) {
                        errorMessage = error.response.data.error;
                    }

                    toast.error(errorMessage, {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        progress: undefined,
                        theme: "colored",
                        transition: Slide,
                    });

                    setCode('');

                    // Close modal on error after a short delay
                    setTimeout(() => {
                        handleClose();
                    }, 500);
                } finally {
                    setLoading(false);
                }
            }
        }, 50)

        return () => clearTimeout(delayDebounceFn)
    }, [code, loading, props.openItem])

    // Enhanced completion check for when documents update
    useEffect(() => {
        const currentChinaDocs = props.documents.filter(item => isInChina(item));
        const currentUzDocs = props.documents.filter(item => isInUzbekistan(item));

        // Update our reference count only if we have china documents
        if (currentChinaDocs.length > 0) {
            lastDocumentCount.current = currentChinaDocs.length;
        }

        // More conservative completion check - only if we should check and we're not scanning
        if (shouldCheckCompletion.current &&
            thisOpen &&
            !isScanning.current &&
            !loading &&
            scanCount.current > 0) { // Must have at least one successful scan

            // Clear existing timeout
            if (completionCheckTimeout.current) {
                clearTimeout(completionCheckTimeout.current);
            }

            // Add delay to ensure this isn't a temporary state
            completionCheckTimeout.current = setTimeout(() => {
                const latestChinaDocs = props.documents.filter(item => isInChina(item));
                const latestUzDocs = props.documents.filter(item => isInUzbekistan(item));

                // Check if all china documents have been scanned (moved to uz)
                const allCompleted = (
                    latestChinaDocs.length === 0
                );

                if (allCompleted &&
                    shouldCheckCompletion.current && // Double check
                    !isScanning.current) { // Make sure we're not scanning

                    finish.play();
                    toast.success("Barchasi muvaffaqiyatli saqlandi!", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        progress: undefined,
                        theme: "colored",
                        transition: Slide,
                    })
                    props.messageReset()

                    // Reset flags to prevent repeated completion
                    shouldCheckCompletion.current = false;

                    // Close the modal after showing the success message
                    setTimeout(() => {
                        handleClose();
                    }, 300);
                }
            }, 400); // Delay to ensure data is properly updated
        }
    }, [props.documents, thisOpen, loading, trackType]);

    // Handle legacy message-based completion - FIXED TO WORK FOR BOTH TYPES
    useEffect(() => {
        const chinaDocs = props.documents.filter(item => isInChina(item));
        const uzDocs = props.documents.filter(item => isInUzbekistan(item));

        if (props.message === true && chinaDocs.length > 0){
            // Still have documents to process, refresh data
            const data = {
                "part": params['part'],
                "code": params['code'],
                "type": trackType
            }
            props.getAlLThis(data)
            props.messageReset()
        } else if (props.message === true && chinaDocs.length === 0) {
            // All items are scanned for BOTH avia and fura
            finish.play();
            toast.success("Barchasi muvaffaqiyatli saqlandi!", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                theme: "colored",
                transition: Slide,
            })
            props.messageReset()

            setTimeout(() => {
                handleClose();
            }, 300);
        } else if (props.message === 'error') {
            audio.play()
            toast.error("Xatolik! Trek kod to'g'ri kelmadi!", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                theme: "colored",
                transition: Slide,
            })
            props.messageReset()

            // CLOSE MODAL ON ERROR AS REQUESTED
            setTimeout(() => {
                handleClose();
            }, 200); // Close after toast disappears
        }
    }, [props.message, props.documents, params, props.openItem, trackType])

    // Cleanup timeouts on unmount
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
        return () => {
            if (completionCheckTimeout.current) {
                clearTimeout(completionCheckTimeout.current);
            }
        };
    }, []);

    return <div>
        <Dialog
            open={open}
            onClose={handleClose}
            BackdropProps={{
                onClick: handleClose
            }}
            sx={{
                '& .MuiDialog-container': {
                    alignItems: 'flex-start'
                }
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    overflow: 'auto',
                }}>
                <div style={{padding:'20px 20px 30px 20px', overflow: "hidden"}}>
                    <h3 className={'page-title text-center'}>{"Iltimos Scan Qiling!"}</h3>
                    <div className={'scan-block'}>
                        <div className={"fingerprint scanning"}>
                            <img src={scan_img} alt="Scan"/>
                        </div>
                    </div>
                    <TextField
                        ref={textFieldRef}
                        onChange={(e) => setCode(e.target.value)}
                        value={code}
                        required
                        className={"inp-text"}
                        onBlur={e => e.target.focus()}
                        type={"text"}
                        autoFocus={true}
                        variant="outlined"
                        placeholder={loading ? "O'zgartirilmoqda..." : "Trek kodni kiriting"}
                    />
                </div>
            </Box>
        </Dialog>
    </div>
}

export default connect(props => props.documents, {
    getDocument,
    getAllVerifyResponse,
    getAlLThis,
    messageReset
})(EditDocument)